<template>
    <svg
        width="19mm"
        height="13mm"
        viewBox="0 0 18.999998 13.000001"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect
            style="
                opacity: 1;
                fill: #fff;
                fill-opacity: 1;
                stroke: #155dc7;
                stroke-width: 0.7;
                stroke-linecap: round;
                stroke-linejoin: round;
                stroke-miterlimit: 42.9;
                stroke-dasharray: none;
                stroke-opacity: 1;
            "
            width="17.5"
            height="11.5"
            x="0.75"
            y="0.75"
            ry="1.15"
        />
    </svg>
</template>
